import { Configuration } from './common/configuration/models/configuration';
import { SearchAdempimentiResponse } from './common/models/dto/search-adempimenti-response';
import { Provenienza } from './common/models/tipologiche/provenienza';
import { TipoDocumento } from './common/models/tipologiche/tipo-documento';
import { TipoTipologica } from './common/models/tipologiche/tipo-tipologica';
import { TipoVisibilita } from './common/models/tipologiche/tipo-visibilita';
import { TipiVisibilita } from './core/configuration/tipi-visibilita';
import { NotificaAttivitaResponse } from './core/models/notifica-attivita-response';
import { PrendiAttivitaCompletareResponse } from './core/models/prendi-attivita-completare-response';
import { ElaborationDocStatus } from './document-management/models/elaboration-doc-status';
import { PctInfoFascicolo } from './pda/models/sections/pct-info-fascicolo';


export class AppData {
  private static _instance: AppData = new AppData();
  temporaryFaccette = null;
  faccetteDaApplicare = [];
  searchAsc: boolean = null;
  searchNomeCampoOrdinamento: string = null;
  nomeCampoOrdinamento: string = null;
  loggedUser: any = null;
  tipiDocumento: TipoDocumento[] = null;
  prossimiAdempimenti: SearchAdempimentiResponse = null;
  adempimentiInevasi: SearchAdempimentiResponse = null;
  notifiche: NotificaAttivitaResponse = null;
  attivitaCompletare: PrendiAttivitaCompletareResponse = null;
  tipiProvenienzaDocumento: Provenienza[] = null;
  userRoles: Array<{id: string, nomeRuolo: string}> = null;
  tipiVisibilitaOptions: TipoVisibilita[] = [];
  statiElaborazioneDocumenti: ElaborationDocStatus[] = null;
  tipiPratica: TipoTipologica[] = null;
  descrittori:any = null;
  descrittoriSezione: any = null;
  SSO_LDAP_CHANGEPWD_ON: {valore: boolean} = null;
  configurations: Configuration[] = null;
  TNT_TENANT: string = null;
  idpHint: string = null;

  private constructor() {
    if (AppData._instance) {
      return AppData._instance;
    }
    AppData._instance = this;
  }

  public setTipiVisibilita(tipoVisibilita: TipoVisibilita[]): void {
    let riservatissima = tipoVisibilita.findIndex(x => x.id === 'ROL_VISIBILITA|RISERVATISSIMA');
    let riservata = tipoVisibilita.findIndex(x => x.id === 'ROL_VISIBILITA|RISERVATA');
    let visibililta = new TipiVisibilita();

    if(riservatissima > -1) {
      this.tipiVisibilitaOptions = visibililta.getTipiVisibilitaByRoleType("RISERVATISSIMA");
      return
    }

    if(riservata > -1 ) {
      this.tipiVisibilitaOptions = visibililta.getTipiVisibilitaByRoleType("RISERVATA");
      return
    }

    this.tipiVisibilitaOptions = visibililta.getTipiVisibilitaByRoleType("default");
  }


  public static getInstance(): AppData {
    return AppData._instance;
  }
}
